import { ExperienceAnchor } from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../i18next';
import {
  getFixedDeadlineSummaryText,
  getFixedTimingSummaryText,
  IItemTemplateTimingFixedTaskWithModes,
  IItemTemplateTimingFixedWithAnchorMode
} from '../../../../../../services/experiences/anchorMode';
import { useMilestoneShortLabel } from '../../../Anchors';
import * as UX from '../../newux/kit';

/** NEW_UX read-only line for a fixed-time item, phrased in the mode the author chose. */
export const FixedTimingSummary = ({
  timing,
  anchor,
  tz
}: {
  timing: IItemTemplateTimingFixedWithAnchorMode;
  anchor: ExperienceAnchor;
  tz: string;
}) => {
  const { t } = useUnsafeTranslation();
  const milestoneLabel = useMilestoneShortLabel(anchor);
  return (
    <UX.TimingSummaryText
      text={getFixedTimingSummaryText(timing, anchor, tz, milestoneLabel, t)}
    />
  );
};

/**
 * NEW_UX read-only line for a fixed task's deadline. Renders `children` (the
 * caller's plain-duration wording) when the deadline has no milestone or
 * calendar-date phrasing.
 */
export const FixedDeadlineSummary = ({
  timing,
  anchor,
  tz,
  children
}: {
  timing: IItemTemplateTimingFixedTaskWithModes;
  anchor: ExperienceAnchor;
  tz: string;
  children: React.ReactNode;
}) => {
  const { t } = useUnsafeTranslation();
  const milestoneLabel = useMilestoneShortLabel(anchor);
  const text = getFixedDeadlineSummaryText(timing, anchor, tz, milestoneLabel, t);
  return text === null ? <>{children}</> : <UX.TimingSummaryText text={text} />;
};
